module.exports = __webpack_public_path__ + "assets/htu-11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/HTU-modal/htu-11.jpg
// module id = 1198
// module chunks = 7